module.exports = __webpack_public_path__ + "img/banner1.26421b3c.png";